import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { IClientNumber } from "src/app/models/client/client-number";
import { ICoverPage } from "src/app/models/cover-page/cover-page";

@Component({
  selector: "app-cover-page-form",
  templateUrl: "./cover-page-form.component.html",
  styleUrls: ["./cover-page-form.component.scss"],
})
export class CoverPageFormComponent implements OnInit, OnChanges {
  @Input() coverPage: Partial<ICoverPage> | null = null;
  @Input() isSaving = false;
  @Input() clientNumbers: IClientNumber[] = [];

  @Output() save = new EventEmitter();

  form: UntypedFormGroup;

  get clientNumberOptions() {
    return this.clientNumbers.map(clientNumber => clientNumber.number);
  }

  onSubmit() {
    if (this.form.valid && !this.isSaving) {
      this.save.emit(this.form.value);
    }
  }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      title: new UntypedFormControl("", Validators.required),
      fromNumber: new UntypedFormControl("", Validators.required),
      sentFrom: new UntypedFormControl("", Validators.required),
    });

    this.patchFormWithCoverPage();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.coverPage && !changes.coverPage.firstChange) {
      this.patchFormWithCoverPage();
    }
  }

  private patchFormWithCoverPage() {
    if (!this.form) {
      return;
    }

    const primaryClientNumber = this.clientNumbers.find(number => number.isPrimary)?.number ?? "";

    const { title = "", fromNumber = primaryClientNumber, sentFrom = "" } = this.coverPage ?? {};

    this.form.patchValue({ title, fromNumber, sentFrom });
  }
}
